import React from 'react';
import { Link } from 'react-router-dom';
import { nav, contact, footer } from '../mock';
import { openCookieSettings } from '../lib/consent';

const Footer = () => {
  return (
    <footer className="bg-ink text-bone">
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src="/kepp-logo.webp?v=2"
              alt="KEPP"
              className="h-10 md:h-12 w-auto object-contain"
            />
            <p className="mt-8 max-w-sm text-sm font-light leading-relaxed text-bone/70">
              {footer.description}
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.25em] text-bone/40">Navigation</div>
            <ul className="mt-6 space-y-3">
              {nav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="link-underline text-sm font-light text-bone/80 hover:text-bone"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-bone/40">Kontakt</div>
            <ul className="mt-6 space-y-3 text-sm font-light text-bone/80">
              <li>{contact.address}</li>
              <li>{contact.zip}</li>
              <li>
                <a href={`mailto:${contact.email}`} className="link-underline hover:text-bone">
                  {contact.email}
                </a>
              </li>
              <li>
                <a href={`tel:${contact.phoneRaw}`} className="link-underline hover:text-bone">
                  Tlf. {contact.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-bone/15 flex flex-col md:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.2em] text-bone/40">
          <span>&copy; {new Date().getFullYear()} Kepp & Co. · CVR {contact.cvr}</span>
          <div className="flex flex-wrap gap-x-6 gap-y-3">
            <Link data-testid="footer-privacy-link" to="/privatlivspolitik" className="hover:text-bone transition-colors">
              Privatlivspolitik
            </Link>
            <Link data-testid="footer-cookie-policy-link" to="/cookiepolitik" className="hover:text-bone transition-colors">
              Cookiepolitik
            </Link>
            <button
              data-testid="footer-cookie-settings-btn"
              onClick={openCookieSettings}
              className="text-left uppercase tracking-[0.2em] hover:text-bone transition-colors"
            >
              Cookieindstillinger
            </button>
          </div>
          <span>{footer.tagline}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
